import { UIFlightData } from "@flights/types";
import React from "react";
import styles from "./WishlistWidgetWrapper.module.css";
import { useFlightWishlistAdaptor } from "./useFlightWishlistAdaptor";
type WishlistWidgetWrapperProps = {
  flight?: UIFlightData;
};

/**
 * WishlistWidgetWrapper Component
 *
 * This component is part of a portal-based rendering system where:
 * 1. It creates a placeholder div with flight data.
 * 2. `<WishlistWidget>` remote component (currently rendered in the FlightDetails page) observes the DOM for elements with 'data-wishlist-flight' attribute.
 * 3. When found, it injects the actual wishlist widget into this div using React portals.
 *
 * @param {UIFlightData} flight - Flight data object
 * @returns A container div that serves as a portal target for the wishlist widget
 */

const WishlistWidgetWrapper = ({ flight }: WishlistWidgetWrapperProps) => {
  const { flightPriceDetails, flightSegmentDetails, ...searchDetails } = useFlightWishlistAdaptor(flight);

  if (!flight || !flightSegmentDetails || !flightPriceDetails) {
    return null;
  }

  const { token, offerKeyToHighlight } = flight;

  const flightProps = {
    token,
    flightKey: offerKeyToHighlight,
    flightSearchDetails: searchDetails,
    flightSegmentDetails,
    ...flightPriceDetails
  };

  return <div className={styles.wishlistWidget} data-wishlist-flight={JSON.stringify(flightProps)} />;
};

export default WishlistWidgetWrapper;
